export default {
	'userCancel': '用戶取消',
	'addrLp': 'LP合約地址',
	'bscInLbb': '跨鏈',
	'goSwap': 'CSwap交易',
	'sumLbb': '累計{0} OC',
	'lookLbb': '查看 OC 合約',
	'addrLbb': 'OC 合約地址',
	'addrDead': '黑洞地址',
	'addrMarket': '行銷地址',
	'ratioTotal': '賣出總滑點：10%',
	'ratioLp': 'a.流動性係數：5%',
	'ratioDead': 'b.銷毀係數：3%',
	'ratioInv': 'c.邀請係數：1%',
	'ratioMarket': 'd.行銷係數：1%',
	'contractDesc': '邏輯全鏈實現',
	'contract': '合約',
	'inviteTotal': '全網邀請獎勵：{0} OC',
	'inviteMy': '我的邀請獎勵：{0} OC',
	'lpTotal': '全網流動性獎勵：{0} OC',
	'lpMy': '我的流動性獎勵：{0} OC',
	'lpDesc': '我的/全網流動性：{0} / {1} LCC',
	'lpAdd': '添加流動性',
	'lp': '流動性',
	'invSell': '最高1%邀請獎勵',
	'lpSell': '持有流動性加權獎勵每筆賣出的5%',
	'myInvites': '我的邀請',
	'effective': '有效',
	'ineffective': '無效',
	'myInviter': '我的推薦人',
	'invite': '邀請',
	'inviteNotice1': '給對方發送0.1 OC',
	'inviteNotice2': '待對方確認後，即邀請成功',
	'inviteBind': '請綁定您的推薦人',
	'chainConfirm': '上鏈中···',
	'{0} Operate Fast': '{0}操作太頻繁，請{1}秒後繼續',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': '確認',
	'Osnft Detail': '查看詳情',
	'{0} Not Enogugh': '您的{0}不足',
	'Operate Success': '操作成功',
	'zlang143': '複製成功',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'addrLock': 'Token 鎖倉合約',
	'lockedBalance': '鎖倉地址',
	'ocLockTitle': 'OC 鎖倉合約',
	'ocLockDeposit': '存款',
	'ocLockActive': '狀態',
	'ocLockReleased': '已釋放',
	'ocLockClaim': '提現',
	'lockTotal': '總額',
	'lockDays': '剩餘/鎖倉',
	'lockClaimable': '可提取',
	'lockClaimed': '已提取',
	'Balance Query': '鎖倉地址',
	'Input Address': '請輸入地址',
	'Query': '查詢',
	'Query Result': '查詢結果',
	'No Deposits': '暫無鎖倉記錄',
	'Refresh': '刷新',
	'No Records': '暫無記錄',
	'eventLogs': '事件日誌',
	'eventCount': '記錄數',
	'eventTotal': '金額彙總',
	'eventAll': '全部',
	'eventInviteFeature': '邀請功能',
	'eventRewardFeature': '獎勵功能',
	'eventBonusFeature': '挖礦功能',
	'eventLockFeature': '鎖倉功能',
	'eventLock': '鎖倉',
	'eventRelease': '釋放',
	'eventClaim': '提取',
	'eventBonus': '分紅',
	'eventInvite': '邀請',
	'eventTransfer': '轉入',
	'eventOcLocked': 'OC鎖倉',
	'eventOcStaticRelease': '靜態釋放',
	'eventOcDynamicRelease': '動態釋放',
	'eventOcClaimed': '鎖倉提取',
	'eventBonusTriggered': '動能分配',
	'eventBonusReceived': '動能到帳',
	'eventInviteRequested': '請求邀請',
	'eventDirectReward': '直推獎勵',
	'eventLiquidityReward': '流動性獎勵',
	'eventSlowQueryProgress': '查詢較慢，已查詢 {0} / {1} 區塊',
	'eventTenLevelBonus': '十層挖礦',
	'eventTenLevelBonusReceived': '十層挖礦到帳',
	'eventReferralConfirmed': '邀請確認',
	'eventEffectiveInvite': '有效邀請',
	'eventEffectiveLp': '有效帳戶',
	'eventTransferIn': '轉入',
	'Please Input Address': '請輸入有效的地址',
	'Lp Bonus Balance': '動態挖礦餘額',
	'Lp Bonus Distributed': '動態挖礦已產出',
	'addrBonus': '動態挖礦合約',
	'fund5': '基金會锁仓10年',
	'ecoBurn5': '生態銷毀锁仓10年锁仓10年',
	'genesis5': '創世團隊锁仓10年',
	'tech3': '技術服務锁仓10年',
	'market10': '市值管理锁仓10年',
	'coFound30': '聯創團隊锁仓10年',
	'lpDepth10': '我的動態挖礦獎勵：{0} OC',
	'themeNeon': '霓虹藍紫',
	'themeIce': '冰藍電路',
	'themeViolet': '紫金夜色',
	'themeAurora': '極光薄荷',
	'themeEmber': '焰火暗夜',
	'themeMono': '深空冷灰',
	'delLpTimeScale': '2月內撤流動性最多 3 倍暴擊',
	'Day': '天',
}
